import { render, staticRenderFns } from "./LinkedFieldsTagsBrowser.vue?vue&type=template&id=d97ef41c&"
import script from "./LinkedFieldsTagsBrowser.vue?vue&type=script&lang=js&"
export * from "./LinkedFieldsTagsBrowser.vue?vue&type=script&lang=js&"
import style0 from "./LinkedFieldsTagsBrowser.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports